import {useUniqueTrackingSessionId} from '@aboutyou/tracking';
import React from 'react';
import {CheckoutEntryDetails} from '../hooks/useCheckoutEntryDetails';
import {CheckoutDataLayerInterceptor} from './CheckoutDataLayerInterceptor';

export const WebCheckoutDataLayerInterceptor: React.FC<{
  entryDetails?: CheckoutEntryDetails;
}> = ({entryDetails}) => {
  const gaSessionId = useUniqueTrackingSessionId();

  return (
    <CheckoutDataLayerInterceptor
      device={process.env.STACK!}
      gaSessionId={gaSessionId}
      checkoutEntryDetails={entryDetails}
    />
  );
};
